import React, { useContext, useState } from "react";
import HeaderNav from "../components/HeaderNav";
import Hero from "../components/Hero";
import Footer from "../components/Footer";
import { Link, Navigate, useNavigate } from "react-router";
import {
  BodyText,
  NormalHeading,
  PayPaystack,
  SubHeading,
  ToastError,
  ToastSuccess,
} from "../global/component";
import { FaRegCircle, FaRegDotCircle } from "react-icons/fa";
import AuthContext from "../global/auth-context";
import CopyToClipboard from "react-copy-to-clipboard";
import { MdContentCopy } from "react-icons/md";
import { Analytics } from "@vercel/analytics/react";
import { GetPlanService } from "../models/ApiService";

const Premium = () => {
  const [getPlan, setGetPlan] = useState(false);
  const [payOnline, setPayOnline] = useState(false);
  const [payBankTransfer, setPayBankTransfer] = useState(false);
  const [payUSDT, setPayUSDT] = useState(false);
  const [planName, setPlanName] = useState(null);
  const [duration, setDuration] = useState(null);

  let navigate = useNavigate();

  let {
    plans,
    userdata,
    fetchUserData,
    user,
    isAuth,
    setAmount,
    amount,
    adminDetails,
  } = useContext(AuthContext);

  async function PaymentSuccessfull(params) {
    ToastSuccess("Payment Successful");
    let payload = { user, planName, duration };
    let response = await GetPlanService(payload);
    if (response.success == true) {
      ToastSuccess(response.message);
      fetchUserData(user);
      window.scrollTo(0, 0);
      navigate("/");
    } else {
      ToastError(response.message);
    }
  }

  return (
    <>
      <Analytics />
      {!isAuth ? (
        navigate("/login", { replace: true })
      ) : (
        <div className="flex flex-col justify-between h-full">
          <HeaderNav page={"premium"} />
          <Hero>
            <div className="flex flex-col md:px-32 py-5 gap-7 h-full justify-center px-5">
              <div className="flex flex-wrap gap-3 md:gap-7">
                <p className=" text-white font-bold md:text-5xl text-3xl md:w-full">
                  Subscribe to Our
                </p>
                <span className=" text-yellow-400 font-bold md:text-5xl text-3xl">
                  Premium Plans
                </span>
                <span className=" text-white font-bold md:text-5xl text-3xl">
                  Here
                </span>
              </div>
              <p className=" text-white font-normal text-xl md:text-2xl w-2/3">
                Premium users gets access to our well analyzed tips with high
                winning probability
              </p>
              <p className=" text-white font-normal text-xl md:text-2xl w-2/3">
                <span className=" text-yellow-500 font-normal text-xl">
                  Note:{" "}
                </span>{" "}
                Premium Tips are not fixed games or matches.
              </p>
            </div>
          </Hero>

          {getPlan == false && (
            <div className="flex py-10 px-5 w-full justify-center items-center gap-5 flex-wrap bg-myLightGreen">
              {plans.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="w-screen items-center h-fit p-5 flex-col gap-3 bg-white rounded-2xl border-2 border-myNormalGreen justify-between flex lg:w-96 md:w-96 sm:w-96"
                    style={{
                      boxShadow: 10,
                    }}
                  >
                    <NormalHeading Text={item.planName} TextColor={"#016401"} />
                    <NormalHeading
                      Text={"Price: " + item.planAmount}
                      TextColor={"#016401"}
                    />
                    <NormalHeading
                      Text={"Duration: " + item.planDuration + " days"}
                      TextColor={"#016401"}
                    />
                    <text className="flex text-start self-start">
                      - Access to Premium Tips, A minimum of 2 Premium Tips
                      daily
                    </text>
                    <text className="flex text-start self-start">
                      - Access to the Worksheet, The Worksheet comprises of the
                      best games shared every weekend
                    </text>
                    <text className="flex text-start self-start">
                      - Access to Rollover challenges
                    </text>
                    <Link
                      onClick={() => {
                        setGetPlan(true);
                        setPayOnline(true);
                        setPlanName(item.planName);
                        setDuration(item.planDuration);
                        setAmount(item.planAmount);
                      }}
                      className="bg-myNormalGreen py-1 px-3 rounded-lg text-white"
                    >
                      Get Plan
                    </Link>
                  </div>
                );
              })}
            </div>
          )}

          {getPlan && (
            <div className="flex flex-col py-10 px-5 bg-myLightGreen">
              <text className="font-bold text-myNormalGreen text-xl sm:text-2xl lg:text-3xl pb-5">
                How Would you like to pay?
              </text>
              <div className="flex w-full items-start justify-center flex-col md:flex-row gap-5">
                <div
                  className={` ${
                    payOnline && "border-2 border-myNormalGreen p-5 bg-white"
                  } w-full md:w-96  items-center justify-center gap-3 flex flex-col `}
                >
                  <Link
                    onClick={() => {
                      setPayOnline(true);
                      setPayBankTransfer(false);
                      setPayUSDT(false);
                    }}
                    className="flex gap-2  w-full md:w-96  items-center justify-center hover:text-myNormalGreen"
                  >
                    {payOnline == false ? (
                      <FaRegCircle />
                    ) : (
                      <FaRegDotCircle color="#016401" size={30} />
                    )}
                    <text
                      className={`${
                        payOnline && " font-bold"
                      } text-xl md:text-2xl`}
                    >
                      Pay Online
                    </text>
                  </Link>
                  {payOnline && (
                    <div className="flex items-center justify-center flex-col">
                      <text className="text-center">
                        Process payment of the sum of {amount} Naira for {planName} Below <br /> <br />
                      </text>
                      <PayPaystack
                        user={user}
                        amount={amount * 100}
                        success={PaymentSuccessfull}
                      />
                    </div>
                  )}
                </div>
                <div
                  className={` ${
                    payBankTransfer &&
                    "border-2 border-myNormalGreen p-5 bg-white"
                  } w-full md:w-96  items-center justify-center gap-3 flex flex-col`}
                >
                  <Link
                    onClick={() => {
                      setPayOnline(false);
                      setPayBankTransfer(true);
                      setPayUSDT(false);
                    }}
                    className="flex gap-2  w-full md:w-96  items-center justify-center hover:text-myNormalGreen"
                  >
                    {payBankTransfer == false ? (
                      <FaRegCircle />
                    ) : (
                      <FaRegDotCircle color="#016401" size={30} />
                    )}
                    <text
                      className={`${
                        payBankTransfer && " font-bold"
                      } text-xl md:text-2xl`}
                    >
                      Manual Payment
                    </text>
                  </Link>
                  {payBankTransfer && (
                    <div className="flex items-center justify-center flex-col">
                      <text className="text-center">
                        Transfer the sum of {amount} Naira for {planName} to the account details Below <br /> <br />{" "}
                        <span className="font-bold">
                          {" "}
                          {adminDetails.bank.bankName} <br />
                          <span className="flex gap-2 text-center justify-center">
                            {adminDetails.bank.accountNumber}
                            <CopyToClipboard
                              text={adminDetails.bank.accountNumber}
                            >
                              <Link
                                onClick={() => {
                                  ToastSuccess("Account Number Copied");
                                }}
                                className="flex gap-1 items-center"
                              >
                                <MdContentCopy color="#016401" />
                              </Link>
                            </CopyToClipboard>{" "}
                          </span>
                          {adminDetails.bank.accountName}
                        </span>
                        <br /> <br /> submit proof of payment below
                      </text>
                      <Link className="flex py-1 bg-myNormalGreen px-3 text-white rounded-md md:text-xl mt-5">
                        Submit Receipt
                      </Link>
                    </div>
                  )}
                </div>
                <div className={`w-full md:w-96  flex flex-col`}>
                  {!payUSDT && (
                    <Link
                      onClick={() => {
                        setPayOnline(false);
                        setPayBankTransfer(false);
                        setPayUSDT(true);
                      }}
                      className="flex gap-2  w-full md:w-96  items-center justify-center hover:text-myNormalGreen"
                    >
                      <FaRegCircle />

                      <text className={` text-xl md:text-2xl`}>
                        USDT Payment
                      </text>
                    </Link>
                  )}
                  {payUSDT && (
                    <div
                      className=" flex flex-col bg-white w-full items-center py-5 border-myNormalGreen border-2 
                    px-5
                    "
                    >
                      <div className="flex text-myNormalGreen gap-2 items-center">
                        <FaRegDotCircle size={30} />

                        <text
                          className={`${
                            payUSDT && " font-bold"
                          } text-xl md:text-2xl`}
                        >
                          USDT Payment
                        </text>
                      </div>
                      <text className="text-center text-wrap my-3">
                        Send ${amount / 1000} worth of USDT for {planName} Plan to the wallet address Below <br /> <br />
                      </text>
                      <div className="font-bold flex flex-col items-center px-3">
                        <span className=" text-myNormalGreen flex">
                          Wallet Adress:
                        </span>
                        <div className="flex items-center justify-center flex-row text-sm gap-1 sm:text-base">
                          <text className="flex flex-wrap text-wrap self-center">
                            {adminDetails.usdt.walletAddress}
                          </text>
                          <CopyToClipboard
                            text={adminDetails.usdt.walletAddress}
                          >
                            <Link
                              onClick={() => {
                                ToastSuccess("Address Copied");
                              }}
                              className="flex items-center flex-wrap"
                            >
                              {" "}
                              <MdContentCopy color="#016401" size={20} />
                            </Link>
                          </CopyToClipboard>{" "}
                        </div>
                        <br />
                        <span className=" text-myNormalGreen">
                          {" "}
                          Network: <br />
                        </span>
                        <div className="flex gap-2 text-center justify-center">
                          {adminDetails.usdt.network}
                          <CopyToClipboard text={adminDetails.usdt.network}>
                            <Link
                              onClick={() => {
                                ToastSuccess("Network Copied");
                              }}
                              className="flex gap-1 items-center "
                            >
                              {" "}
                              <MdContentCopy color="#016401" />
                            </Link>
                          </CopyToClipboard>
                        </div>
                      </div>
                      <text className="text-center text-wrap px-10">
                        submit proof of payment below
                      </text>
                      <Link className="flex py-1 bg-myNormalGreen px-3 text-white rounded-md md:text-xl mt-5">
                        Submit Receipt
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          <Footer />
        </div>
      )}
    </>
  );
};

export default Premium;
